/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KpiValueFormat } from './kpi-value-format';
import { ChartConfigurationSchema } from './chart-configuration-schema';
import { KpiParameterDto } from './kpi-parameter-dto';


export interface CreateVersionDto { 
    /**
     * Metric presentation type. count, amount and percentage render one value; trend returns one row per time bucket (bucket, value) and needs valueFormat; chart requires chartConfig. A percentage value is a ratio, so 0.25 is shown as 25%: never multiply by 100 in SQL.
     */
    type: CreateVersionDto.TypeEnum;
    /**
     * How a trend KPI\'s values are formatted. Required when type is trend; must be null or omitted for every other type. A percentage value is a ratio, so 0.25 is shown as 25%: never multiply by 100 in SQL.
     */
    valueFormat?: KpiValueFormat | null;
    /**
     * Parameterized, read-only SQL using {{placeholders}}.
     */
    sql: string;
    /**
     * Required when type is chart; must be null or omitted for scalar metric types.
     */
    chartConfig?: ChartConfigurationSchema | null;
    /**
     * Parameters the SQL declares as `{{placeholders}}`, with their type, default and option source.
     */
    parameters?: Array<KpiParameterDto>;
    /**
     * Plain-language explanation of what the SQL computes, shown next to the metric and used when an agent has to pick between KPIs.
     */
    queryExplanation?: string;
    /**
     * Why this version was created, kept as the version\'s changelog entry.
     */
    revisionReason?: string;
    /**
     * Metric artifact this version was promoted from, recorded for lineage.
     */
    sourceArtifactId?: string;
}
export namespace CreateVersionDto {
    export const TypeEnum = {
        Amount: 'amount',
        Count: 'count',
        Chart: 'chart',
        Percentage: 'percentage',
        Trend: 'trend'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


